<script>
export default {
    name: "GrnPostedList",
    data () {
        return {

            grnLines: [],
              suppliers:[],
            filter:{
             search:"",
             supplierId:0,
             SearchOnly:false,
             dateFrom: window.moment().format(`YYYY-MM-DD`),
             dateTo: window.moment().format(`YYYY-MM-DD`),
                },
        };
    },

    mounted() {

        this.fetchAll();
         this.fetchSuppliers();
    },

    methods: {

        fetchAll() {

            this.$root.loading = true;
            this.$accountsHttp.get('SupplierGRN/UnPostedGRN').then(response => {
                this.grnLines = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },fetchSupplierGrn() {
            this.filter.SearchOnly=false;
           
            let url = `SupplierGRN/GetUnPostedSupplierGoodsReturnNotes`;
                url +=`?SupplierId=${this.filter.supplierId}`;
                url +=`&DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
                url +=this.filter.search ? `&SearchField=${this.filter.search}` : ``;
                url +=`&SearchOnly=${this.filter.SearchOnly}`;
               return this.$http.get(url).then(({ data }) => {
                this.grnLines = data;
            }).catch(() => {});
        },
          fetchSupplierGrnSearchOnly() {
            this.filter.SearchOnly=true;
            let url = `SupplierGRN/GetUnPostedSupplierGoodsReturnNotes`;
                url +=`?SupplierId=${this.filter.supplierId}`;
                url +=`&DateFrom=${this.filter.dateFrom}&DateTo=${this.filter.dateTo}`;
                url +=this.filter.search ?`&SearchField=${this.filter.search}` : ``;
                url +=`&SearchOnly=${this.filter.SearchOnly}`;
                 return this.$http.get(url).then(({ data }) => {
                this.grnLines = data;
            }).catch(() => {});
        },
          fetchSuppliers() {
            let url = `Shared/GetSuppliers`;

            return this.$http.get(url).then(({ data }) => {
                this.suppliers = data;
            }).catch(() => {});
        }
    },
}
</script>
<template>
   <div class="flex flex-wrap content-start overflow-auto" style="height:78vh;">
        <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-search" class="label-control">Search:</label>
                  <input type="text" v-model.trim="filter.search" 
                    @keydown.enter="fetchSupplierGrnSearchOnly" 
                    placeholder="press enter to search only"
                    id="grid-search" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-from" class="label-control">From:</label>
                  <input type="date" v-model.trim="filter.dateFrom" 
                    id="grid-date-from" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/6 sm:w-full p-tiny">
                  <label for="grid-date-to" class="label-control">To:</label>
                  <input type="date" v-model.trim="filter.dateTo" 
                    id="grid-date-to" class="input-control input-sm text-xs">
              </div>
              <div class="md:w-1/5 sm:w-full p-tiny">
                  <label for="grid-cashier" class="label-control">Supplier:</label>
                  <v-select
                v-model="filter.supplierId" 
                :options="suppliers" 
                :reduce="supplier => supplier.id"
                label="name"
                class="bg-white text-sm" 
            />
              </div>
              
              <div class="md:w-1/12 sm:w-full p-tiny mt-4">
                  <button class="btn-sm btn-info text-xs rounded" 
                    @click.prevent="() => {
                        $root.loading=true;
                        fetchSupplierGrn().then(() => {
                            $root.loading=false;
                        }).catch(() => { $root.loading=false; });
                    }">
                        <i class="fa fa-filter"></i> Filter</button>
              </div>
        <table class="table table-hover">
            <thead class="bg-blue-500 text-xs text-white">
                <tr class="w-full flex">
                    <td class="p-tiny w-1/6">Supplier</td>
                    <td class="p-tiny w-1/6">Grn No</td>
                    <td class="p-tiny w-1/6">Txn Date</td>
                    <td class="p-tiny w-1/6">Invoice Ref</td>
                    <td class="p-tiny w-1/6">Memo</td>
                    <td class="p-tiny w-1/6">User</td>
                    <td class="p-tiny w-1/6">Grand total</td>
                    <td class="p-tiny w-1/6">Action</td>
                </tr>
            </thead>
            <tbody class="flex flex-col items-center text-xs bg-gray-100 overflow-auto" style="height:70vh;">
                <tr class="w-full flex" v-for="(grnLine, idx) in grnLines" :key="idx">
                    <td class="p-tiny w-1/6">{{ grnLine.supplier }}</td>
                    <td class="p-tiny w-1/6">{{ grnLine.grnNo }}</td>
                    <td class="p-tiny w-1/6">{{ grnLine.txnDate | dateFormat }}</td>
                    <td class="p-tiny w-1/6">{{ grnLine.invoiceRef }}</td>
                    <td class="p-tiny w-1/6">{{ grnLine.memo }}</td>
                    <td class="p-tiny w-1/6">{{ grnLine.userName }}</td>
                    <td class="p-tiny w-1/6">{{ grnLine.grandTotal }}</td>
                    <td class="p-tiny w-1/6">
                       
                            <router-link class="btn-sm btn-info text-xs rounded m-1" 
                            :to="{ name: 'suppliers-dashboard.grn-list.view', params: { GRNNO:  grnLine.grnNo } }" title="View">
                                <i class="fa fa-eye"></i></router-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
